import { render, staticRenderFns } from "./imgInfo.vue?vue&type=template&id=668f5440&"
import script from "./imgInfo.vue?vue&type=script&lang=js&"
export * from "./imgInfo.vue?vue&type=script&lang=js&"
import style0 from "./imgInfo.vue?vue&type=style&index=0&id=668f5440&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports